const translations = {
  // Reward Modal
  'modal.reward.shop.now.btn': 'Shop now',
  'modal.reward.nocard.title.green': 'Unlock a world of benefits',
  'modal.reward.nocard.title': 'by linking your credit card with us!',
  'modal.reward.nocard.description': 'Not only will you be supporting our mission, but you\'ll also earn exciting rewards that you can enjoy. Don\'t miss out on this opportunity to give back while treating yourself!',
  'modal.reward.nocard.btn': 'Link my card',
  'modal.reward.nocard.back': 'Go back to the offers',
  // Link card modal
  'modal.link.card.form.title': 'Add Credit Card',
  'modal.link.card.creating.title': 'Link Credit Card',
  'modal.link.card.success.title': 'You\'re all set!',
  'modal.link.card.success.content': 'Browse through the hundreds of offers we have for you. And thank you!',
  'modal.link.card.success.cta': 'Check more offers',
  'modal.link.card.error.title': 'There was an error',
  'modal.link.card.error.content': 'Please try again.',
  'modal.link.card.cardexists.title': `You're subscribed`,
  'modal.link.card.cardexists.content': 'You are already subscribed!',
  'modal.link.card.membership_activated' : 'Membership Activated',
  'modal.link.card.enjoy_benefits' : 'Enjoy your benefits',
  // Card modal
  "modal.card.cta.error": "There was an error",
  "modal.card.program.terms.prompt": "Click here to read the full program terms.",
  // set primary
  "modal.card.set-primary.title": "Set as primary card",
  "modal.card.set-primary.description": "Set this card as primary",
  "modal.card.set-primary.cta": "Set primary card",
  "modal.card.set-primary.success": "Card set as primary successfully!",
  // Activate
  "modal.card.activate.title": "Activate card",
  "modal.card.activate.description": "Start supporting our mission again with this card.<br><strong>Save Money and Do Good!</strong>",
  "modal.card.activate.cta": "Activate card",
  "modal.card.activate.success": "Card activated successfully!",
  "modal.card.primary.delete": "Please, select another card to use as primary before deleting this card.",
  // Pause
  "modal.card.pause.title": "Pause card activity",
  "modal.card.pause.description": "Your donations will be temporarily paused until you reactivate your card. During this period, <strong>no new donations will be made</strong>.<br><br>Donations made before the pause will be debited at the end of the month. Your transactions will continue to be monitored during this period to ensure the correct rewards payment.",
  "modal.card.pause.warning": "Your {balance} reward balance will be lost.",
  "modal.card.pause.confirm": "Yes, I agree to these terms.",
  "modal.card.pause.cancel": "Keep my card active",
  "modal.card.pause.tooltip": "To avoid losing your rewards, keep your card active or paused until the payment is credited.",
  "modal.card.pause.cta": "Pause card activity",
  "modal.card.pause.success": "Card paused successfully!",
  // Delete
  "modal.card.delete.title": "Delete my card",
  "modal.card.delete.description": "By selecting this option, your card will be removed and you will no longer have access to the offers and discounts in this program. This may take up to 3 business days. Any donations made up until the date of deletion, will be charged to this credit card on the first day of the next month. Please note, if the round-ups during this period are less than $10, your card will be charged the minimum amount of $10. In addition, any cashback accrued to this point will no longer be available for withdrawal.",
  "modal.card.delete.warning": "Your {balance} reward balance will be lost.",
  "modal.card.delete.confirm": "Yes, I agree to these terms.",
  "modal.card.delete.cancel": "Keep my card active",
  // TODO Add paused to description
  "modal.card.delete.tooltip": "To avoid losing your rewards, keep your card active until the payment is credited.",
  "modal.card.delete.cta": "Delete my card",
  "modal.card.delete.success": "Card deleted successfully!",
  // How it works
  "modal.how-it-works.roundup.title": "Save Money and Do Good!",
  "modal.how-it-works.subscription.title": "Save Money and Support Student Athletes!",
  "modal.how-it-works.whitelabel.title": "Save Money and Do Good!",
  "modal.how-it-works.subtitle": "Not only will you be supporting our mission, but you'll also earn exciting rewards that you can enjoy. Don't miss out on this opportunity to give back while treating yourself!",
  // Membership
  "modal.membership.top-header": "Complete your membership setup",
  "modal.membership.top-header.member": "Upgrade your membership",
  "modal.membership.sub-header": "Select a plan",
  "modal.membership.tier.list.annual.subtitle": "Save up to ${price}",
  "modal.membership.tier.list.annual-to-monthly.title": "You still have {days} days in your current {tier} annual plan",
  "modal.membership.tier.list.annual-to-monthly.description": "You're enrolled in an annual plan. Therefore, monthly plans are not available at the moment. If you would like to change from an annual plan to a monthly plan, please contact our support team here: {email}.",
  "modal.membership.see-details": "See Details",
  "modal.membership.hide-details": "Hide Details",
  "modal.membership.change-tier": "Change Tier",
  "modal.membership.get-started": "Get Started",
  "modal.membership.current-plan": "Current Plan",
  "modal.membership.not-available": "Not Available",
  "modal.membership.downgrade-tier": "Upcoming Plan",
  "modal.membership.change": "change",
  "modal.membership.downgrade": "Downgrade",
  "modal.membership.notice": "The {plan} Tier includes a Round-up component of which rounds up your daily transactions tied to your enrolled credit card to the nearest dollar.",
  "modal.membership.price": "${price}/mo",
  "modal.membership.price.new": "{price}{sub}",
  "modal.membership.plans.discount": "Save ${value}",
  "modal.membership.default-plan": "Roundup",
  "modal.membership.min-monthly": "${min} Min, ${max} Max",
  "modal.membership.unlimited-round-up": "Flexible",
  "modal.membership.payment-processing-fee": "{$min} Min",
  "modal.membership.includes": "Includes",
  "modal.membership.benefits-plus": "benefits, plus",
  "modal.membership.upgrade": "Upgrade",
  "modal.membership.upgrade.confirm.message": "Do you confirm the upgrade to the {plan} plan?",
  "modal.membership.upgrade.confirm.message.secondary": "You will not be able to downgrade afterwards.",
  "modal.membership.select.confirm.message": "Do you want to enroll in the {plan} plan?",
  // Cancel membership
  "modal.membership.delete.title": "Cancel Membership",
  "modal.membership.delete.roundup.description": "Once you have selected to cancel your membership, you will be un-enrolled from the Membership Program and lose all access to perks and rewards. This action may take up to 2-3 business days. Any round-up amount accrued before cancelling the plan will be charged to the enrolled card within the first week of the following month.",
  "modal.membership.delete.subscription.description": "Once you have selected to cancel your membership, you will be un-enrolled from the Program and lose all access to perks and rewards. This action may take up to 2-3 business. Any outstanding membership fees for the current period will be charged within the first week of the following month.",
  "modal.membership.delete.whitelabel.description": "Once you have selected to cancel your membership, you will be un-enrolled from the Membership Program and lose all access to perks and rewards. This action may take up to 2-3 business days. Any round-up amount accrued before cancelling the plan will be charged to the enrolled card within the first week of the following month.",
  "modal.membership.delete.warning": "Your {balance} reward balance will be lost.",
  "modal.membership.delete.confirm": "Yes, I agree to these terms.",
  "modal.membership.delete.cancel": "Keep my membership active",
  "modal.membership.delete.tooltip": "To avoid losing your rewards, keep your card active until the payment is credited.",
  "modal.membership.delete.cta": "Cancel my membership",
  "modal.membership.delete.success": "Your Membership has been canceled.",
  "modal.membership.delete.error": "There was an error.",
  // Sweepstakes modal
  "modal.sweepstakes.title": "Monthly member giveaway",
  "modal.sweepstakes.subtitle": "You have {entries} entries for the next draw.",
  // Referral Rock
  "modal.referral-rock.roundup.step1": "Invite friends with your link",
  "modal.referral-rock.roundup.step2": "They join and support the charity for 3 months",
  "modal.referral-rock.roundup.step3": "You get {reward}. Repeat for more",
  "modal.referral-rock.subscription.step1": "Invite friends and family using your unique link",
  "modal.referral-rock.subscription.step2": "They sign up for the {clientName} Team",
  "modal.referral-rock.subscription.step3": "You receive {reward} Cashback",
  "modal.referral-rock.whitelabel.step1": "Invite friends with your link",
  "modal.referral-rock.whitelabel.step2": "They join and support for 3 months",
  "modal.referral-rock.whitelabel.step3": "You get {reward}. Repeat for more",
  // Confirm Changes
  "modal.downgrade.confirm.change": "Confirm Change",
  "modal.downgrade.review.changes": "Review Changes",
  "modal.downgrade.new.plan": "New Plan",
  "modal.downgrade.current.plan": "Current Plan",
  "modal.downgrade.effect": "Changes will take effect on",
  "modal.downgrade.cancel": "Cancel",
}

export default translations;